import { useMemo } from "react";
import { SWRConfiguration, SWRResponse } from "swr";

import { NewGetSiteEventGalleryCollection, NewGetSiteEventGalleryCollectionResponse } from "../../api/dtos/dtos";
import useGet from "../api/useGet";


const getData = (response?: SWRResponse<NewGetSiteEventGalleryCollectionResponse, NewGetSiteEventGalleryCollectionResponse>) => response?.data?.galleryItems;
const getError = (response?: SWRResponse<NewGetSiteEventGalleryCollectionResponse, NewGetSiteEventGalleryCollectionResponse>) => (response?.error ?? response?.data)?.responseStatus;
const getAdditionalState = (_?: SWRResponse<NewGetSiteEventGalleryCollectionResponse, NewGetSiteEventGalleryCollectionResponse>) => ({});

const useGetSiteEventGetCollectionGallery = (query?: Partial<NewGetSiteEventGalleryCollection>, configuration?: SWRConfiguration) => {
    const request = useMemo(() => {
        if (!query) {
            return undefined;
        }

        return () => {
            return new NewGetSiteEventGalleryCollection(query);
        }
    }, [query]);

    return useGet(request, { getData, getError, getAdditionalState }, configuration);
}

export default useGetSiteEventGetCollectionGallery;